/**
 * @flow
 * @relayHash 523569ec82a31338f83e827271401641
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TopicsApp_viewer$ref = any;
export type queries_TopicsQueryVariables = {|
  section: string
|};
export type queries_TopicsQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: TopicsApp_viewer$ref
  |}
|};
export type queries_TopicsQuery = {|
  variables: queries_TopicsQueryVariables,
  response: queries_TopicsQueryResponse,
|};
*/


/*
query queries_TopicsQuery {
  viewer {
    ...TopicsApp_viewer_1hrbBR
    id
  }
}

fragment TopicsApp_viewer_1hrbBR on Viewer {
  ...TopicsList_viewer
}

fragment TopicsList_viewer on Viewer {
  topics(first: -1) {
    edges {
      node {
        id
        hidden
        ...TopicsListItem_topic
      }
    }
  }
}

fragment TopicsListItem_topic on Topic {
  id
  name
  slug
  hidden
  seoTitle
  seoDescription
  seoKeywords
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "section",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_TopicsQuery",
  "id": null,
  "text": "query queries_TopicsQuery {\n  viewer {\n    ...TopicsApp_viewer_1hrbBR\n    id\n  }\n}\n\nfragment TopicsApp_viewer_1hrbBR on Viewer {\n  ...TopicsList_viewer\n}\n\nfragment TopicsList_viewer on Viewer {\n  topics(first: -1) {\n    edges {\n      node {\n        id\n        hidden\n        ...TopicsListItem_topic\n      }\n    }\n  }\n}\n\nfragment TopicsListItem_topic on Topic {\n  id\n  name\n  slug\n  hidden\n  seoTitle\n  seoDescription\n  seoKeywords\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_TopicsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TopicsApp_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_TopicsQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "topics",
            "storageKey": "topics(first:-1)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": -1,
                "type": "Int"
              }
            ],
            "concreteType": "TopicConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TopicEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Topic",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hidden",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "seoTitle",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "seoDescription",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "seoKeywords",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '13bdd4b37adfeb806cd399dee9173389';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_TopicsQuery.graphql.js